import { render, staticRenderFns } from "./InvestmentInfo.vue?vue&type=template&id=a8b50400&scoped=true&"
import script from "./InvestmentInfo.vue?vue&type=script&lang=js&"
export * from "./InvestmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentInfo.vue?vue&type=style&index=0&id=a8b50400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b50400",
  null
  
)

export default component.exports